import { RootState } from '../store';

const select = (state: RootState) => state.timeAndPeople;

export const selectTimeAndPeoplePageData = (state: RootState) => select(state);
